import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";
import Loader from "components/loader/Loader";
import { Link } from "react-router-dom";
import faqModel from "models/faq.model";

const Faqs = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [perPage, setPerPage] = useState(20);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListData = async () => {
    setIsLoading(true);
    
    // Dummy data to replace API call
    const dummyData = [
      {
        _id: "1",
        id: "1",
        question: "How do I register as a tutor?",
        answer: "You can register as a tutor by clicking on the 'Become a Tutor' button and filling out the registration form with your qualifications and experience.",
        priority: "High",
        Added_ON: "2024-01-15",
        type: "Registration"
      },
      {
        _id: "2",
        id: "2",
        question: "What subjects can I teach?",
        answer: "You can teach any subject you are qualified for, including Mathematics, Science, English, Social Studies, and various competitive exam preparations.",
        priority: "Medium",
        Added_ON: "2024-01-16",
        type: "Teaching"
      },
      {
        _id: "3",
        id: "3",
        question: "How do I get paid?",
        answer: "Payments are processed weekly through bank transfer or UPI. You can set up your payment preferences in your profile settings.",
        priority: "High",
        Added_ON: "2024-01-17",
        type: "Payment"
      },
      {
        _id: "4",
        id: "4",
        question: "Can I teach online and offline both?",
        answer: "Yes, you can choose to teach both online and offline classes based on your preference and student requirements.",
        priority: "Medium",
        Added_ON: "2024-01-18",
        type: "Teaching"
      },
      {
        _id: "5",
        id: "5",
        question: "What are the minimum qualifications required?",
        answer: "Minimum qualification is graduation in the relevant subject. Additional certifications and teaching experience are preferred.",
        priority: "High",
        Added_ON: "2024-01-19",
        type: "Qualification"
      },
      {
        _id: "6",
        id: "6",
        question: "How do I schedule classes?",
        answer: "You can schedule classes through your dashboard by selecting available time slots and coordinating with students.",
        priority: "Low",
        Added_ON: "2024-01-20",
        type: "Scheduling"
      }
    ];
    
    setTimeout(() => {
      setIsLoading(false);
      setDataList(dummyData);
      setCurrentPage(1);
      setPerPage(20);
    }, 1000);
  };

  useEffect(() => {
    getListData();
  }, [location]);

  // console.log(dataList.data, "dataList");

  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this FAQ", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          // Simulate delete operation
          setTimeout(() => {
            setDataList(prevData => prevData.filter(item => item.id !== delId));
            helper.sweetalert.toast("FAQ deleted successfully", "success");
          }, 500);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast("Error deleting FAQ", "warning");
      });
  };

  return (
    <>
      <div className="pt-7 px-4">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">All Faqs</h3>

                <div className="d-flex flex-row">
                  {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                  <Input
                    className="mr-4"
                    type="text"
                    placeholder="Search"
                    size="sm"
                  />
                  <Button
                    size="sm"
                    to="/admin/fAQs/addfAQs/"
                    tag={Link}
                  
                    style={{backgroundColor:"#080278",color:"white",border:"none"}}
                  >
                    +Add
                  </Button>
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">S.NO.</th>
                    <th scope="col">Question</th>
                    <th scope="col">Answer</th>
                    <th scope="col">Priority</th>
                    <th scope="col">Added ON</th>
                    <th scope="col">Type</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                {isLoading ? (
                                                <tr>
                                                  <td
                                                    colSpan={12}
                                                    className="text-center align-middle w-full"
                                                  >
                                                    Please wait...
                                                    <Loader />
                                                  </td>
                                                </tr>
                                              ) : dataList.length > 0 ? 
                                              (
                      dataList
                        ?.slice()
                        .reverse()
                        .map((item, index) => {
                        
                          // let currentDate = new Date(item.createdAt);
                          // let formattedDate = currentDate
                          //   .toISOString()
                          //   .substring(0, 10);
                          return (
                            <tr key={item._id}>
                              <td>{index + 1}</td>
                              <td>{item.question || "-"}</td>
                              <td>{item.answer || "-"}</td>
                              <td>{item.priority || "-"}</td>
                              <td>{item.Added_ON || "-"}</td>
                              <td>{item.type || "-"}</td>

                              <td
                             
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  // justifyContent: "center",
                                  // alignItems: "center",
                                }}
                              >
                                <UncontrolledTooltip
                                  placement="top"
                                  target="eyeTooltip"
                                >
                                  Edit
                                </UncontrolledTooltip>
                                <Link
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "blue",
                                    // backgroundColor: "#f5f5f5",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "30%", // Optional: Make it a circle
                                  }}
                                  id="eyeTooltip"
                                  to={`/admin/fAQs/editfAQs/${item.id}`}
                                >
                                  <i className="fa-solid fa-pen-to-square"></i>
                                </Link>

                                <UncontrolledTooltip
                                  placement="top"
                                  target="userTooltip"
                                
                                >
                                  Delete
                                </UncontrolledTooltip>
                                <p
                                  style={{
                                    margin: "0 8px",
                                    fontSize: "15px",
                                    color: "red",
                                    marginTop: "10px",
                                    // backgroundColor: "#f5f5f5",
                                    display: "inline-block",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "20%", // Optional: Make it a circle
                                  }}
                                  id="userTooltip"
                                  onClick={() => handleDel(item.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </p>
                              </td>
                            </tr>
                          );
                        })
                    ) : 
                    (
                      <tr style={{ textAlign: "center" }}>
                        <td colSpan="6" style={{ verticalAlign: "middle" }}>
                          No data found
                        </td>
                      </tr>
                    )}
                 
                 </tbody>
              </Table>
              <CardFooter className="py-4">
                {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
              </CardFooter>
            </Card>
          </div>
        </Row>

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </div>
    </>
  );
};

export default Faqs;
